import React from 'react';
import {
	ButtonIcon,
	FormikTextEntryStandard,
	LegalString,
	Text,
} from '@stashinvest/react-components';
import { Form, Formik } from 'formik';
import { SendIcon } from '@stashinvest/react-assets';
import { v1_AiChat_Submitted } from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';
import { v1_AiChat_SubmittedProperties } from '@stashinvest/product-events-javascript/lib/v1/properties';

export const ChatForm = ({ onSubmit, disabled, analytics, track, input = '' }) => {
	return (
		<>
			<Formik
				initialValues={{
					chat_input: input,
				}}
				onSubmit={(values) => {
					input = '';
					if (!!values.chat_input) {
						onSubmit(values.chat_input);
						track(
							v1_AiChat_Submitted({
								...analytics,
								is_topic: v1_AiChat_SubmittedProperties.IsTopic.no,
							})
						);
					}
					values.chat_input = '';
				}}
			>
				<Form className="flex items-center justify-between my-content3XS">
					<FormikTextEntryStandard
						className="w-full mr-contentXS"
						label="Let's talk about money..."
						error={null}
						inputType={null}
						fieldType="simple"
						name="chat_input"
						data-testid="chat-input"
					/>
					<button type="submit" disabled={disabled} data-testid="chat-submit-button">
						<ButtonIcon Icon={SendIcon} isEnabled={!disabled} variant="primary" />
					</button>
				</Form>
			</Formik>
			<LegalString className="my-content3XS">
				{`Stash's AI Money Coach is in beta mode. By using AI Money Coach, you agree
							to these `}
				<Text
					tag="a"
					href="https://cdn.stash.com/disclosures/stash-money-coach-beta-program-terms-and-conditions.pdf"
				>
					Terms and Conditions
				</Text>
				.
			</LegalString>
		</>
	);
};
